import { Box } from '@/components/ui/box'
import { IApproval, IApprovalDetail, ICompliance, IField, ITaskDetail } from '@/types/tasksApprovals'
import { isSailPointCertDecision, isSapLeaveRequest } from '@/utils/approvals'

import Assignee from '../assignee'
import DefaultField from './default'
import AwardReason from './name/awardReason'
import Number from './name/number'
import RequestedPermission from './name/permission'
import AmountInput from './type/amountInput'
import CommentsType from './type/comments'
import DateType from './type/date'
import DateInterval from './type/dateInterval'
import DrowpDown from './type/dropdown'
import LinkType from './type/link'
import NumberType from './type/number'
import TNETable from './type/table/TNE'
import TimeOfDetails from './type/timeOffDetails'
import User from './type/user'

const Fields = ({
    item,
    details,
    parentURL,
}: {
    item: ICompliance | IApproval
    details: ITaskDetail | IApprovalDetail | null
    parentURL?: string
}) => {
    const generateFields = (field: IField) => {
        switch (field.name) {
            case 'Number':
                return <Number item={field} href={parentURL} />
            case 'Requested Permission':
                if (item.system_id === 'SHAREPOINT') {
                    return <RequestedPermission item={field} />
                }
                break
            case 'Award Reason':
                if (item.system_id === 'GRP') {
                    return <AwardReason item={field} />
                }
                break
            default:
                break
        }

        switch (field.type) {
            case 'table':
                if (item.system_id === 'TNE') {
                    return <TNETable item={field} />
                }
                break
            case 'number':
                return <NumberType item={field} />
            case 'user':
                return <User item={field} />
            case 'comments':
                return <CommentsType item={field} />
            case 'date':
                return <DateType item={field} system={item.system_id} />
            case 'date-interval':
                return <DateInterval item={field} />
            case 'input':
                if (item.system_id === 'GRP') {
                    return <AmountInput item={field} />
                }
                break
            case 'time_off_details':
                if (item.system_id === 'WORKDAY_LEAVE_REQUESTS') {
                    return <TimeOfDetails item={field} />
                }
                break
            case 'link':
                return <LinkType item={field} />
            case 'categories':
                if (item.system_id === 'GRP') {
                    return <DrowpDown item={field} />
                }
                break
            default:
                return <DefaultField item={field} />
        }
    }

    return (
        <>
            <Assignee details={details} />
            {details?.fields.map((field: IField) => {
                if (isSailPointCertDecision(item) && field.name === 'Title') {
                    return null
                }

                // These 2 fields will be handled in RequestPeriod component
                if (isSapLeaveRequest(item) && (field.name === 'Start Date' || field.name === 'End Date')) {
                    return null
                }

                if (field.section === 'More Details' || field.section === 'More Information' || field.type === 'checkbox') {
                    return null
                }

                return (
                    <Box position="relative" key={field.name}>
                        {generateFields(field)}
                    </Box>
                )
            })}
        </>
    )
}

export default Fields
